// extracted by mini-css-extract-plugin
module.exports = {"img":"BenefitIcon_img__2IKfN"};